import React from 'react'
import { Image } from 'react-bootstrap'
import classNames from 'classnames'

import '../../../assets/sass/components/images/avatar.scss'

const Avatar = ({
    name = "Guest",
    src,
    containerClassName = '',
    size = "lg",
    variant = "primary",
    ...props
}) => {
    const hasImage = !!src;

    return (
        <div className={classNames(
            "avatar", 
            containerClassName,
            size,
            `bg-${variant}`,
            { 'has-image': hasImage }
        )}>
            {hasImage ? (
                <Image src={src} alt={name} {...props} />
            ): (
                getInitials(name)
            )}
        </div>
    )
}

const getInitials = name => {
    var initials = name.match(/\b\w/g) || [];
    initials = ((initials.shift() || '') + (initials.pop() || '')).toUpperCase();
    return initials;
}

export default Avatar
